/**
 * SmartInspect assessment placeholder (Sprint 8B). The full assessment
 * detail / creation flow is intentionally NOT built yet. Access is gated by
 * the shared application-access logic (hasApp).
 */
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Wrench } from "lucide-react";
import { useConsultant } from "./ConsultantLayout";
import { hasApp, APP_SMARTINSPECT } from "../lib/applications";
import { Button } from "../components/ui/button";

export default function SmartInspectAssessmentPlaceholderPage() {
  const user = useConsultant();
  const navigate = useNavigate();
  const { id } = useParams();
  const isNew = !id || id === "new";

  useEffect(() => {
    if (user && !hasApp(user, APP_SMARTINSPECT)) navigate("/transformation", { replace: true });
  }, [user, navigate]);

  if (!user || !hasApp(user, APP_SMARTINSPECT)) return null;

  return (
    <div data-testid="smartinspect-assessment-placeholder" className="max-w-2xl">
      <button
        data-testid="si-placeholder-back"
        onClick={() => navigate("/consultant/smartinspect")}
        className="inline-flex items-center gap-1.5 text-sm text-[#6B7280] hover:text-[#111827] mb-4"
      >
        <ArrowLeft className="w-4 h-4" /> Back to SmartInspect Dashboard
      </button>
      <div className="rounded-xl border border-[#E5E7EB] bg-white p-8 text-center">
        <div className="mx-auto w-14 h-14 rounded-full bg-[#F0F9FF] flex items-center justify-center mb-4">
          <Wrench className="w-7 h-7 text-[#025979]" strokeWidth={1.4} />
        </div>
        <h1 className="text-xl font-bold text-[#111827]">
          {isNew ? "New ROI Assessment" : "SmartInspect Assessment"}
        </h1>
        <p className="text-sm text-[#6B7280] mt-2">
          {isNew
            ? "Assessment creation will be implemented in an upcoming release."
            : "The assessment detail workspace will be implemented in an upcoming release."}
        </p>
        {!isNew && <p className="text-xs text-[#9CA3AF] mt-2">Assessment ID: {id}</p>}
        <Button
          data-testid="si-placeholder-back-btn"
          variant="outline"
          onClick={() => navigate("/consultant/smartinspect")}
          className="mt-5"
        >
          Return to Dashboard
        </Button>
      </div>
    </div>
  );
}
